<template>
    <div class="search_box" v-bind:style="{ height: Height + 'px' }">
        <!-- 文献查找 -->
        <el-container>
            <el-main
                v-bind:style="{ height: Height + 'px' }"
                v-loading="pageLoading"
                element-loading-text="加载中..."
                style="background: #f5f5f5; box-sizing: border-box;"
            >
                <div :key="keys" class="citation-page-wrap">
                    <citationTrace v-if="keys == '1'"></citationTrace>
                    <citationTraceEn v-else-if="keys == '2'"></citationTraceEn>
                    <citationTraceList v-else-if="keys == '3'"></citationTraceList>
                    <citationTracePersonal v-else-if="keys == '4'"></citationTracePersonal>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import citationTrace from './citationTrace.vue'
import citationTraceEn from './citationTraceEn.vue'
import citationTraceList from './citationTraceList.vue'
import citationTracePersonal from './citationTracePersonal.vue'
import bus from "@/utils/eventBus";
import {
    judge_user
} from "@/Api/unquote";
export default {
    data() {
        return {
            keys: "",
            Height: 0,
            pageLoading: false,
            pageLoadingTimer: null,
        }
    },
    components: {
        citationTrace,
        citationTraceEn,
        citationTraceList,
        citationTracePersonal
    },
    mounted() {
        //动态设置内容高度 让footer始终居底   header+footer的高度是190
        this.Height = document.documentElement.clientHeight - 80; //监听浏览器窗口变化
        window.onresize = () => {
            this.Height = document.documentElement.clientHeight - 80;
        };
        // 监听当前页面 显示状态
        window.addEventListener("visibilitychange", this.hanldeVisiblityChange);

        // 当页面被销毁时 移除监听
        this.$on("hook:beforeDestroy", () => {
            // console.info("ws 我被销毁了, 移除监听>>>");
            window.removeEventListener(
                "visibilitychange",
                this.hanldeVisiblityChange
            );
        });
    },
    created() {
        if (this.$route.query.webPage) {
            this.keys = this.$route.query.webPage.toString();
        }
        if (sessionStorage.getItem("citation_page_loading") === "1") {
            this.pageLoading = true;
            this.scheduleHidePageLoading();
        }
        bus.$on("citation-page-loading", this.handleCitationPageLoading);
        this.user_mes();
    },
    beforeRouteUpdate(to, from, next) {
        if (to.query.webPage) {
            const nextKey = to.query.webPage.toString();
            if (nextKey !== this.keys) {
                this.switchPage(nextKey);
            }
        }
        next();
    },
    beforeDestroy() {
        bus.$off("citation-page-loading", this.handleCitationPageLoading);
        this.clearPageLoadingTimer();
    },
    // 监听路由变化
    watch: {
        $route(to) {
            if (to.query.webPage) {
                const nextKey = to.query.webPage.toString();
                if (nextKey !== this.keys) {
                    this.switchPage(nextKey);
                }
            }
        },
    },
    methods: {
        handleCitationPageLoading(loading) {
            if (loading) {
                this.pageLoading = true;
                this.clearPageLoadingTimer();
            }
        },
        switchPage(key) {
            sessionStorage.removeItem("citation_page_loading");
            this.pageLoading = true;
            this.keys = key;
            this.scheduleHidePageLoading();
        },
        scheduleHidePageLoading() {
            this.clearPageLoadingTimer();
            this.$nextTick(() => {
                this.pageLoadingTimer = setTimeout(() => {
                    this.pageLoading = false;
                    this.pageLoadingTimer = null;
                    sessionStorage.removeItem("citation_page_loading");
                }, 320);
            });
        },
        clearPageLoadingTimer() {
            if (this.pageLoadingTimer) {
                clearTimeout(this.pageLoadingTimer);
                this.pageLoadingTimer = null;
            }
        },
        user_mes() {
            let user_ids = {
                user_openid: localStorage.getItem("code"),
            };
            judge_user(user_ids)
                .then((res) => {
                    console.log(res);
                    
                    localStorage.setItem("en_name",res.data.user_mes[0].en_user_name)
                  
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    }
}
</script>

<style lang="less" scoped>
.search_box{
    box-sizing: border-box;
    overflow: auto;

    .citation-page-wrap {
        min-height: 100%;
    }
    
    ::v-deep .el-main {
        min-width: 1130px;
        height: 100%;
        background-color: #e9eef3;
        color: #333;
    }
}
</style>